import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Loader, Navigation } from '@vinted/web-ui';
import { getPaymentAuth, getThreeDS2Configuration } from 'state/extra-service/selectors';
import PaymentAuth from 'components/PaymentAuth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ExtraServicePaymentAuth = _ref => {
  var _paymentAuth$embedded;

  let {
    onError,
    onCancel,
    onAuthSubmitted
  } = _ref;
  const paymentAuth = useSelector(getPaymentAuth);
  const threeDS2Config = useSelector(getThreeDS2Configuration);
  const {
    0: isLoading,
    1: setIsLoading
  } = useState(true);

  function handleInputRequested() {
    setIsLoading(false);
  }

  function renderLoader() {
    if (!isLoading) return null;
    return /*#__PURE__*/_jsx("div", {
      className: "threeds2__extra-service-loader",
      "data-testid": "3ds-loader",
      children: /*#__PURE__*/_jsx(Loader, {
        size: Loader.Size.X2Large
      })
    });
  }

  const authAction = (_paymentAuth$embedded = paymentAuth.embedded) === null || _paymentAuth$embedded === void 0 ? void 0 : _paymentAuth$embedded.authAction;
  if (!authAction || !threeDS2Config) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: "threeds2__challenge-modal",
    children: [/*#__PURE__*/_jsx(Navigation, {
      right: /*#__PURE__*/_jsx(Button, {
        inline: true,
        deprecatedIconName: "x",
        styling: Button.Styling.Flat,
        testId: "extra-service-payment-auth-modal--close",
        onClick: onCancel
      })
    }), renderLoader(), /*#__PURE__*/_jsx(PaymentAuth, {
      authAction: authAction,
      threeDS2Config: threeDS2Config,
      onInputRequested: handleInputRequested,
      onContinue: onAuthSubmitted,
      onError: onError
    })]
  });
};

export default ExtraServicePaymentAuth;